import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, ArrowUpRight } from "lucide-react";
import { Reveal, ScrollHeading, Eyebrow } from "./ui";
const faqs = [
  {
    question: "What can you help us build?",
    answer:
      "We help with web applications, custom software platforms, mobile apps, internal tools, and integrations. We can also review or improve existing software. The scope starts with your business needs.",
  },
  {
    question: "Can you work with our existing software or team?",
    answer:
      "Yes. We can work alongside your team, review an existing codebase, or take on a defined piece of development. We first assess the system and agree on a practical scope.",
  },
  {
    question: "How can AI help our project or business?",
    answer:
      "AI can help us prototype and iterate more quickly. We can also integrate assistants, document processing, search, or workflow automation into your software. We assess the fit for your use case and data, then agree on how results will be tested and reviewed.",
  },
  {
    question: "How do you estimate cost and timelines?",
    answer:
      "We estimate after discussing the requirements, existing systems, integrations, and delivery priorities. We agree on scope, assumptions, and milestones before work begins, and discuss changes as the project evolves.",
  },
  {
    question: "Do you offer support after launch?",
    answer:
      "We can discuss maintenance, bug fixes, and ongoing development as part of the engagement. Support hours, response expectations, and scope are agreed in advance.",
  },
];
export function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="faq section-pad">
      <div className="wrap faq-layout">
        <Reveal>
          <Eyebrow number="06">Good to know</Eyebrow>
          <ScrollHeading
            lines={[
              { text: "Common", muted: false },
              { text: "questions.", muted: true },
            ]}
          />
          <a className="faq-contact" href="mailto:quantumcodecorp@gmail.com">
            Have a question about your project?
            <ArrowUpRight size={18} />
          </a>
        </Reveal>
        <div className="faq-items">
          {faqs.map((faq, i) => (
            <Reveal
              key={faq.question}
              className={`faq-item ${open === i ? "is-open" : ""}`}
            >
              <h3>
                <button
                  id={`faq-trigger-${i}`}
                  onClick={() => setOpen(open === i ? null : i)}
                  aria-expanded={open === i}
                  aria-controls={`faq-answer-${i}`}
                >
                  <span className="faq-number">0{i + 1}</span>
                  <span>{faq.question}</span>
                  <Plus size={19} />
                </button>
              </h3>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    id={`faq-answer-${i}`}
                    role="region"
                    aria-labelledby={`faq-trigger-${i}`}
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="faq-answer"
                  >
                    <p>{faq.answer}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
